import {
  CLOSE_UPLOAD_MENU_MODAL,
  CREATE_RESTAURANT_SUCCESS,
  TOGGLE_CREATE_MENU,
  TOGGLE_UPDATE_MENU,
} from "../actions/ActionTypes";

const initialState = {
  isShowUploadMenuModal: false,
};

export default function (state = initialState, action) {
  const { type } = action;

  switch (type) {
    case CLOSE_UPLOAD_MENU_MODAL:
      return {
        ...state,
        isShowUploadMenuModal: false,
      };

    case CREATE_RESTAURANT_SUCCESS:
    case TOGGLE_CREATE_MENU:
    case TOGGLE_UPDATE_MENU: {
      return { ...state, isShowUploadMenuModal: true };
    }

    default:
      return state;
  }
}
